import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_VHCL_MDL_NO_CD_SRCH, SCHEMA_GRID_VHCL_MDL_NO_CD } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const VehicleModelNumberCodeList = (props: any) => {
    const pgeUid = "vhclMdlNoCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        vhclMdlNoCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_VHCL_MDL_NO_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        vhclMdlNoCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_VHCL_MDL_NO_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getVhclMdlNoCdLst: useFetch({
            api: (page = grid.vhclMdlNoCdLst.page) => {
                return APIS.getVhclMdlNoCdLst(form.vhclMdlNoCdSrch.getValues(), page, grid.vhclMdlNoCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.vhclMdlNoCdSrch.errors) && form.vhclMdlNoCdSrch.isSubmitted,
            key: [grid.vhclMdlNoCdLst.page, grid.vhclMdlNoCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.vhclMdlNoCdSrch.getValues(),
                    page: grid.vhclMdlNoCdLst.page,
                    size: grid.vhclMdlNoCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.vhclMdlNoCdSrch.handleSubmit(
                () => {
                    grid.vhclMdlNoCdLst.setPage(0);
                    fetch.getVhclMdlNoCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.vhclMdlNoCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_VhclMdlNoCdLst: {
            cell: {
                vhclMdlNoCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.vhclMdlNoNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.vhclMkerCd) {
            form.vhclMdlNoCdSrch.setValue("vhclMkerCd", params.vhclMkerCd);
        }
        if (params?.vhclMdlCd) {
            form.vhclMdlNoCdSrch.setValue("vhclMdlCd", params.vhclMdlCd);
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.vhclMdlNoCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_VHCL_MDL_NO_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.vhclMdlNoCdSrch.schema.vhclMdlNoCd}></Group.Control>
                                <Group.Control {...form.vhclMdlNoCdSrch.schema.vhclMdlNoNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.vhclMdlNoCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.vhclMdlNoCdLst.grid}
                            data={fetch.getVhclMdlNoCdLst.data?.vhclMdlNoList}
                            render={render.grid_VhclMdlNoCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
